import { Link } from "react-router-dom";
import { Mail } from "lucide-react";
import { usePortalMembership, usePortalScope } from "@/contexts/portalScope";

/**
 * The one outstanding program invitation, shown inline at the top of the
 * dashboard.
 *
 * A scoped affiliate belongs to exactly one brand, so an invitations *page*
 * would be a list that never holds more than one row and that nobody thinks to
 * visit. Surfacing it where they land is both simpler and harder to miss.
 *
 * Renders nothing when unscoped, so the marketplace dashboard is unchanged and
 * its dedicated Invitations page stays the way in.
 */
export function ScopedInvitationAlert() {
  const { scope } = usePortalScope();
  const { membership } = usePortalMembership();

  const invitation = membership.pendingInvitation;
  const username = membership.homeBrandUsername ?? scope.homeBrandUsername;
  if (!scope.isScoped || !invitation || !username) return null;

  return (
    <div className="mb-6 flex flex-col gap-3 rounded-lg border border-border bg-muted/40 p-4 sm:flex-row sm:items-center sm:justify-between">
      <div className="flex items-start gap-3">
        <Mail className="mt-0.5 h-5 w-5 shrink-0 text-muted-foreground" />
        <div>
          <p className="font-medium text-foreground">
            You have been invited to join
            {invitation.programName ? ` ${invitation.programName}` : " a program"}
          </p>
          <p className="text-sm text-muted-foreground">
            Accept to get your affiliate link and start earning.
          </p>
        </div>
      </div>
      <Link
        to={`/affiliate/brands/${username}`}
        className="shrink-0 rounded-lg bg-primary px-4 py-2 text-center text-sm font-medium text-primary-foreground transition-opacity hover:opacity-90"
      >
        View invitation
      </Link>
    </div>
  );
}
